/**
 * 工单状态
 */
export default function workOrderStatus(val) {
    let str = '';
    switch (val) {
    case 'CHECKING':
        str = '检测中';
        break;
    case 'UNDER_CONSTRUCTION':
        str = '施工中';
        break;
    case 'IN_DELIVERY':
        str = '车辆交付';
        break;
    case 'COMPLETED':
        str = '已完成';
        break;
    case 'CANCELLED':
        str = '已取消';
        break;
    default:
        break;
    }
    return str;
}
